import { useMainStore } from "@/stores/mainStore";
import { listModule } from "@/types/global";
import { useTranslation } from "i18next-vue";
import { computed, ComputedRef, onMounted, Ref, ref, toRaw } from "vue";
import axios from "axios";

export function useModules(
  allowedEdit: boolean,
  slots: Ref<{}>,
  allSlots: Ref<{}>,
  current_status: Ref<String>,
  licenceId: Ref<number>
) {
  const { t } = useTranslation();
  const mainStore = useMainStore();

  // const status_by_module = computed(() => {
  //   const result = {};
  //   for (const [type, modules] of Object.entries(current_status.value)) {
  //     for (const m of modules as string[]) {
  //       result[m] = type;
  //     }
  //   }
  // });

  onMounted(() => {
    console.log("useModules slots", slots.value);

    for (const module of mainStore.modules) {
      if (module.disabled) continue;
      if (allowedEdit && module.value === 1 << 5) continue;
      console.log("Im here,", slots.value[module.value]);

      const element: listModule = Object.assign({}, module, {
        slots: current_status.value !== null ? slots.value[module.value] : 0,
        monthEnd: Math.max(
          0,
          allSlots.value[module.value] - slots.value[module.value]
        )
      });

      if (slots.value[module.value] === undefined) {
        return [];
      }

      initialItems.value.push(element);
    }
  });

  const headers: any = computed(() => {
    return [
      {
        title: t("views.licence.table.module"),
        align: "start",
        sortable: false,
        key: "module",
        value: (item) => t("views.licence.modules." + item.name + ".name"),
        width: "25%"
      },
      {
        title: t("views.licence.table.description"),
        align: "start",
        sortable: false,
        key: "description",
        value: (item) =>
          t("views.licence.modules." + item.name + ".description"),
        width: "25%"
      },
      {
        title: t("views.licence.table.active"),
        key: "active",
        sortable: false,
        width: "25%",
        hidden: !allowedEdit
      },
      {
        title: t("views.licence.table.slots"),
        key: "slots",
        value: (item) => item.slots,
        width: "25%",
        hidden: allowedEdit
      },
      {
        title: t("views.licence.table.price"),
        key: "price",
        sortable: false,
        align: "end",
        value: (item) => {
          console.log(
            item.module,
            item.price,
            Math.floor(item.price) / 100 + " €"
          );
          return Math.floor(item.price) / 100 + " €";
        },
        width: "25%"
      },
      {
        title: t("views.licence.table.total"),
        key: "priceAll",
        sortable: false,
        align: "end",
        value: (item) => {
          console.log(
            item.module,
            item.price,
            Math.floor(item.price) / 100 + " €"
          );
          return Math.floor(item.price * item.slots) / 100 + " €";
        },
        width: "25%"
      }
    ].filter((i) => !i.hidden);
  });

  const initialItems: Ref<listModule[]> = ref([]);
  const items: ComputedRef<listModule[]> = computed(() => {
    const result = [];
    for (const module of mainStore.modules) {
      if (module.disabled) continue;
      if (allowedEdit && module.value === 1 << 5) continue;

      const element: listModule = Object.assign({}, module, {
        slots: slots.value[module.value],
        monthEnd: Math.max(
          0,
          allSlots.value[module.value] - slots.value[module.value]
        )
        // payment_state: status_by_module.value[module.value]
      });

      result.push(element);
    }


    return result;
  });

  const oldMonthlyCost = computed(() => {
    return (
      initialItems.value.reduce((acc, module) => {
        acc += module.price * module.slots;
        return acc;
      }, 0) / 100
    );
  });

  const monthlyCost = computed(() => {
    return (
      items.value.reduce((acc, module) => {
        acc += module.price * module.slots;
        return acc;
      }, 0) / 100
    );
  });

  const modulesAdded = computed(() => {
    console.log("modulesAdded ", toRaw(items.value), toRaw(initialItems.value));
    return Object.fromEntries(
      items.value.map((module, index) => {
        console.log(module, index, toRaw(initialItems.value[index]));
        return [module.value, module.slots - initialItems.value[index].slots];
      })
    );
  });

  const chargeNeeded = computed(() => {
    console.log(
      "chargeNeeded",
      toRaw(modulesAdded.value),
      toRaw(allSlots.value),
      toRaw(slots.value)
    );
    return Object.entries(modulesAdded.value).reduce((acc, [name, i]) => {
      console.log(
        "chargeNeeded",
        i,
        allSlots.value[name],
        slots.value[name],
        i > 0 && allSlots.value[name] < slots.value[name]
      );
      return i > 0 && allSlots.value[name] < slots.value[name] ? acc + i : acc;
    }, 0);
  });

  const changeNeeded = computed(() => {
    return initialItems.value.reduce((result, initItem, index) => {
      return result || initItem.slots !== items.value[index].slots;
    }, false);
  });

  const modulesRemoved = computed(() => {
    return Object.fromEntries(
      initialItems.value.map((module, index) => [
        module.name,
        module.slots - items.value[index].slots
      ])
    );
  });

  function loadPreview() {
    additionalPrice.value = null;
    const byName = Object.fromEntries(
      mainStore.modules.map((module) => [
        module.name,
        slots.value[module.value]
      ])
    );

    axios
      .post(
        current_status.value !== null
          ? `/api/stripe/preview-sub-update/${licenceId.value}`
          : "/api/stripe/preview-sub-create",
        byName
      )
      .then((response) => {
        console.log("Success", response.data);
        additionalPrice.value =
          response.data.amount_due / 100 +
          " " +
          t("units." + response.data.currency);
      });
  }

  const additionalPrice = ref(null);
  const remainingDays = computed(() => {
    const now = new Date();
    const monthDays = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0
    ).getDate();
    const remainingDays = monthDays - now.getDate() + 1;
    return remainingDays;
  });

  return {
    headers,
    initialItems,
    items,
    oldMonthlyCost,
    monthlyCost,
    modulesRemoved,
    additionalPrice,
    remainingDays,
    loadPreview,
    chargeNeeded,
    changeNeeded
  };
}
